import { Stack } from '@mui/material'
import { styled } from '@mui/material/styles'

const IMG_HEIGHT = '148px'
const IMG_WIDTH = '148px'

export const StyledImageContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  padding: '8px',
  borderRadius: '8px',
  maxHeight: '100%',
}))

export const StyledEmptyImg = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  height: IMG_HEIGHT,
  width: IMG_WIDTH,
  backgroundColor: theme.palette.grey[400],
}))

export const StyledImg = styled('img')(() => ({
  height: IMG_HEIGHT,
  width: IMG_WIDTH,
  borderRadius: '50%',
}))
